<template>
  <MRow :gutter="0">
    <MCol :lg="12" :sm="12" auto-size>
      <MRow>
        <MCol :size="6">
          <FlotoFormItem
            id="name-input"
            :value="formData.name"
            :placeholder="$t('id')"
            :label="$t('id')"
            disabled
          />
        </MCol>
        <MCol :size="6">
          <FlotoFormItem
            id="display-name-input"
            :value="formData.displayName"
            :placeholder="$t('name')"
            :label="$t('name')"
            disabled
          />
        </MCol>
        <MCol :size="6">
          <FlotoFormItem
            id="asset-type-id-picker"
            :placeholder="$tc('asset_type')"
            :label="$tc('asset_type')"
          >
            <FlotoAssetTypePicker
              as-input
              :value="formData.assetTypeId"
              disabled
            />
          </FlotoFormItem>
        </MCol>
        <MCol :size="6">
          <FlotoFormItem
            id="status-id-picker"
            :placeholder="$tc('status')"
            :label="$tc('status')"
          >
            <FlotoStatusPicker
              :module-name="$constants.ASSET"
              :value="formData.statusId"
              disabled
              as-input
            />
          </FlotoFormItem>
        </MCol>
        <MCol :size="6">
          <FlotoFormItem
            id="bar-code-input"
            :value="formData.barCode"
            :placeholder="$t('barcode')"
            :label="$t('barcode')"
            disabled
          />
        </MCol>
        <MCol :size="6">
          <FlotoFormItem
            id="in-warranty-switch"
            :placeholder="$tc('in_warranty')"
            :label="$tc('in_warranty')"
          >
            <MSwitch
              v-model="formData.inWarranty"
              size="small"
              :disabled="movementType === 'return_from_repair'"
            />
          </FlotoFormItem>
        </MCol>
        <MCol :size="12">
          <FlotoFormItem
            id="remarks-input"
            v-model="formData.remarks"
            :placeholder="$tc('remark')"
            :label="$tc('remark')"
            rules="max:255"
            :disabled="movementType === 'return_from_repair'"
          />
        </MCol>
        <MCol v-if="movementType === 'return_from_repair'" :size="6">
          <FlotoFormItem
            id="movement-date-picker"
            :placeholder="$tc('sent_date')"
            :label="$tc('sent_date')"
          >
            <FlotoDatePicker
              :value="formData.movementDate"
              :min-date="Moment().valueOf()"
              disabled
            />
          </FlotoFormItem>
        </MCol>
        <MCol v-if="movementType === 'return_from_repair'" :size="6">
          <FlotoFormItem
            id="reference-number-input"
            :value="formData.referenceNumber"
            :placeholder="`${$tc('reference')} ${$tc('number')}`"
            :label="`${$tc('reference')} ${$tc('number')}`"
            disabled
          />
        </MCol>
        <MCol v-if="movementType === 'return_from_repair'" :size="6">
          <FlotoFormItem
            id="vendor-id-picker"
            :placeholder="`${$tc('vendor')}`"
            :label="`${$tc('vendor')}`"
          >
            <VendorPicker
              :value="formData.vendorId"
              allow-clear
              as-input
              disabled
            />
          </FlotoFormItem>
        </MCol>
        <MCol v-if="movementType === 'return_from_repair'" :size="6">
          <FlotoFormItem
            id="expected-date-picker"
            :placeholder="`${$tc('expected_return_date')}`"
            :label="`${$tc('expected_return_date')}`"
          >
            <FlotoDatePicker :value="formData.expectedDate" disabled />
          </FlotoFormItem>
        </MCol>
        <MCol v-if="movementType === 'return_from_repair'" :size="12">
          <FlotoFormItem
            id="fault-input"
            v-model="formData.fault"
            type="textarea"
            :rows="3"
            rules="max:255"
            :placeholder="`${__tc('fault')}`"
            :label="`${__tc('fault')}`"
          />
        </MCol>
        <MCol v-if="movementType === 'return_from_repair'" :size="6">
          <FlotoFormItem
            id="repair-type-picker"
            :placeholder="`${$tc('repair_type')}`"
            :label="`${$tc('repair_type')}`"
          >
            <AssetMovementRepairTypePicker
              v-model="formData.repairType"
              as-input
            />
          </FlotoFormItem>
        </MCol>
        <MCol v-if="movementType === 'return_from_repair'" :size="6">
          <FlotoFormItem
            id="repair-cost-input"
            v-model="formData.repairCost"
            :placeholder="`${__tc('repair_cost')}`"
            :label="`${__tc('repair_cost')}`"
            type="number"
            :precision="0"
          />
        </MCol>
        <MCol v-if="movementType === 'return_from_repair'" :size="12">
          <FlotoFormItem
            id="solution-input"
            v-model="formData.solution"
            type="textarea"
            :rows="3"
            rules="max:255"
            :placeholder="`${$tc('solution')}`"
            :label="`${$tc('solution')}`"
          />
        </MCol>
        <MCol v-if="movementType === 'return_from_repair'" :size="6">
          <FlotoFormItem
            id="warranty-covered-switch"
            :placeholder="$tc('warranty_covered')"
            :label="$tc('warranty_covered')"
          >
            <MSwitch v-model="formData.warrantyCovered" size="small" />
          </FlotoFormItem>
        </MCol>
        <MCol
          v-if="
            movementType === 'return_from_repair' &&
              formData.repairType === 'not_repaired'
          "
          :size="6"
        >
          <FlotoFormItem
            id="replaced-switch"
            v-model="formData.replaced"
            :placeholder="__tc('replacement')"
            :label="__tc('replacement')"
          >
            <MSwitch v-model="formData.replaced" size="small" />
          </FlotoFormItem>
        </MCol>
        <MCol
          v-if="
            movementType === 'return_from_repair' &&
              formData.repairType === 'not_repaired'
          "
          :size="6"
        >
          <FlotoFormItem
            v-if="formData.replaced"
            id="replaced-by-picker"
            :placeholder="$tc('replaced_by')"
            :label="$tc('replaced_by')"
          >
            <AssetPickerDrawer
              v-model="formData.replaceBy"
              as-input
              :module-name="formData.model"
              :fetch-fn="fetchData"
            />
          </FlotoFormItem>
        </MCol>
      </MRow>
    </MCol>
  </MRow>
</template>
<script>
import CloneDeep from 'lodash/cloneDeep'
import AssetPickerDrawer from '@components/data-picker/asset-picker-drawer'
import AssetMovementRepairTypePicker from '@components/data-picker/asset-movement-repair-type-picker'
import VendorPicker from '@components/data-picker/vendor-picker'
import Moment from 'moment'
import { searchAssetsApi } from '@modules/asset/asset-api'
import { transformSearchCriteriaForServer } from '@data/search'
export default {
  name: 'AssetEditForm',
  components: {
    VendorPicker,
    AssetMovementRepairTypePicker,
    AssetPickerDrawer,
  },
  model: {
    event: 'change',
  },
  props: {
    value: { type: Object, default: undefined },
    movementType: { type: String, default: undefined },
    disabled: { type: Boolean, default: false },
    resetForm: { type: Function, required: true },
  },
  data() {
    this.Moment = Moment
    return {}
  },
  computed: {
    formData: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('change', v)
      },
    },
  },
  watch: {
    'formData.replaced': function(value) {
      if (value === false) {
        this.resetForm({
          ...this.formData,
          replaceBy: 0,
        })
      }
    },
  },
  methods: {
    fetchData(moduleName, searchCriterias, limit, offset) {
      const criterias = CloneDeep(searchCriterias)
      const q = transformSearchCriteriaForServer(moduleName, {
        operator: { value: 'not_equal' },
        paramName: 'movementStatus',
        value: 'in_movement',
        valueType: 'enum',
      })
      criterias.quals.push(q)
      return searchAssetsApi(moduleName, criterias, limit, offset)
    },
  },
}
</script>
